import React from 'react'

function parseQueryParams() {
  try {
    const raw = (typeof window !== 'undefined' && window.location)
      ? window.location.search.replace(/^\?/, '')
      : ''
    const params = new URLSearchParams(raw)
    const code = params.get('code')
    const state = params.get('state')
    const error = params.get('error') || params.get('error_description')
    return { code, state, error }
  } catch {
    return { code: null, state: null, error: 'invalid_callback' }
  }
}

export default function NaverCallbackPage() {
  React.useEffect(() => {
    const { code, state, error } = parseQueryParams()
    try {
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          {
            type: 'naver_oauth',
            code,
            state,
            error,
          },
          window.location.origin
        )
      }
    } catch { }

    // UX: 잠깐 안내 후 닫기
    const t = setTimeout(() => {
      try { window.close() } catch { }
    }, 200)
    return () => clearTimeout(t)
  }, [])

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="text-sm text-slate-600">
        네이버 로그인 처리 중입니다. 잠시만 기다려 주세요…
      </div>
    </div>
  )
}

